// extracted by mini-css-extract-plugin
export default {"wrap":"ButtonEclipse_wrap__suaue","button":"ButtonEclipse_button__YW8H6"};